// extracted by mini-css-extract-plugin
export default {"overlay":"Dialog_overlay__hX-nQ","frame":"Dialog_frame__sFPuf","closeButton":"Dialog_closeButton__ezMsk","body":"Dialog_body__ku28b"};